import { getCurrentTime, DeviceType } from "sb-resp-lib";
import { IDateTimeConfig, IDateTimePhrases, IDateTimeString } from "./Interfaces";

export class DateTimeFormatter {

    config: IDateTimeConfig;
    phrases: IDateTimePhrases;
    timeControl: TimeControl;

    constructor(timeControl: TimeControl, phrases: IDateTimePhrases, config: IDateTimeConfig) {
        this.timeControl = timeControl;
        this.phrases = phrases;
        this.config = config;
    }

    adjustDate(eventDate: string, timeZone: number, deviceType: DeviceType): IDateTimeString {

        let enabledLongDateNames = this.config["enableLongDateNames" + (deviceType as string)];
        let convertedDate = Date.fromISO(eventDate);

        if (!convertedDate) {
            return {
                date: "--",
                dateAndTime: undefined,
                time: "--"
            };
        }

        let newEventDate = getCurrentTime(convertedDate, timeZone);
        let newDate = enabledLongDateNames ? this.formatLongDateString(newEventDate) : convertedDate.formatDate("dd/MM");
        let newTime = newEventDate.formatDate("HH:mm");

        return {
            date: newDate,
            time: newTime,
            dateAndTime: newEventDate
        }
    }

    formatLongDateString(eventDate: Date): string {

        if (this.checkIfDateIsToday(eventDate)) {
            return this.phrases.today;
        }

        if (this.checkIfDateIsTomorrow(eventDate)) {
            return this.phrases.tomorrow;
        }

        var monthName = this.phrases.months[eventDate.getMonth()];
        return "{0} {1}".format(eventDate.getDate(), monthName)
    }

    checkIfDateIsToday(eventDate: Date): boolean {
        let currentDate = this.timeControl.getServerTime();
        return eventDate.getDate() === currentDate.getDate() &&
            eventDate.getFullYear() === currentDate.getFullYear() &&
            eventDate.getMonth() === currentDate.getMonth();
    }

    checkIfDateIsTomorrow(eventDate: Date): boolean {
        let currentDate = this.timeControl.getServerTime();
        let nextDay = new Date(currentDate.getTime());
        nextDay.setDate(currentDate.getDate() + 1);

        return eventDate.getDate() === nextDay.getDate() &&
            eventDate.getFullYear() === nextDay.getFullYear() &&
            eventDate.getMonth() === nextDay.getMonth();
    }
}